"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getClassNames = getClassNames;

var _bind = _interopRequireDefault(require("classnames/bind"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function getClassNames() {
  var classes = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var conditionals = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return (0, _bind.default)(conditionals, classes);
}